import { IContactPageErrorMessages } from '@/dictionaries/pages/contacts/types';
import * as yup from 'yup';

export function getTranslatedSchema(dict: IContactPageErrorMessages) {
  return yup.object().shape({
    form_type: yup.string().default('guest'),
    name: yup.string().required(dict.name),
    surname: yup.string().required(dict.surname),
    message: yup.string().when('form_type', {
      is: 'owner',
      then: (schema) => schema.optional(),
      otherwise: (schema) => schema.required(dict.message),
    }),
    property_description: yup.string().when('form_type', {
      is: 'owner',
      then: (schema) => schema.required(dict.propertyDescription),
      otherwise: (schema) => schema.optional(),
    }),
    villa_address: yup.string().when('form_type', {
      is: 'owner',
      then: (schema) => schema.required(dict.villaAddress),
      otherwise: (schema) => schema.optional(),
    }),
    phone: yup
      .number()
      .typeError(dict.phone.typeError)
      .required(dict.phone.required),
    post_code: yup.string().when('form_type', {
      is: 'owner',
      then: (schema) => schema.required(dict.postCode.required),
      otherwise: (schema) => schema,
    }),
    town_country: yup.string().optional(),
    website: yup.string().optional(),
    email: yup.string().email(dict.email).required(dict.email),
    terms: yup.boolean().oneOf([true], dict.terms).required(dict.terms),
    country_info: yup.object().shape({
      name: yup.string().required(),
      code: yup.string().required(),
      id: yup.number().required(),
      phone: yup.object().shape({
        code: yup.number().required(),
        country: yup.string().required(),
      }),
    }),
    budget: yup.object().shape({
      min: yup.number().default(null).nullable(),
      max: yup.number().default(null).nullable(),
    }),
    dates: yup.object().shape({
      start: yup.date().default(null).nullable(),
      end: yup.date().default(null).nullable(),
    }),
  });
}

export function getBaseTranslatedSchema(dict: IContactPageErrorMessages) {
  return getTranslatedSchema(dict).pick([
    'name',
    'surname',
    'email',
    'phone',
    'terms',
    'country_info',
  ]);
}
